<div class="options">
	<div class="option-title">{{ input.settings.title }}:</div>
	<div *ngIf="input.isLoading">
		<span>{{ 'importPage.transferOutOptions.loadingOptionsMessage' | translate }}</span>
	</div>
	<div *ngIf="!input.isLoading">
		<div *ngIf="!input.options">
			<span>{{ input.settings.placeholder }}</span>
		</div>

		<div *ngIf="input.options">
			<ul *ngIf="input.options.length > 0; else defaultHelperText">
				<li
					*ngFor="let option of input.options"
					[ngClass]="{ selected: option.isSelected }"
					(click)="onSelect(option)"
				>
					{{ option.displayName }}
				</li>
			</ul>
			<ng-template #defaultHelperText
				><span>{{ 'importPage.transferOutOptions.noRecordsFound' | translate }}</span></ng-template
			>
		</div>
	</div>
</div>
